import { render, staticRenderFns } from "./achievementAnalysis.vue?vue&type=template&id=bcb8da76&scoped=true"
import script from "./achievementAnalysis.vue?vue&type=script&lang=js"
export * from "./achievementAnalysis.vue?vue&type=script&lang=js"
import style0 from "./achievementAnalysis.vue?vue&type=style&index=0&id=bcb8da76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb8da76",
  null
  
)

export default component.exports